<template>
  <div id="sidebar">
    <div class="sidebar-logo" @click="vHome()">
      <img :src="logo" />
    </div>
    <div class="sidebar-container" >
      <a class="btn" href="#" @click="vDeconnexion()">{{$_('deconnect')}}</a>
    </div>
    <div class="close-sidebar">
      <span @click="vCloseSidebar"><i class="material-icons">arrow_back</i></span>
    </div>
  </div>
</template>

<script>

import { Bus } from '@/common/Bus';

import customerService from '@/modules/client/services/customerService'

export default {
    data() {
        return {
            link: Array(),
            logo: '',
        }
    },
    created() {
      this.getDivLogo();
    },
    methods: {
        vDeconnexion() {
            localStorage.removeItem('satabapp-research');
            localStorage.removeItem('satabapp-company');
            localStorage.removeItem('satabapp-user');
            localStorage.removeItem('satabapp-token');
            localStorage.removeItem('satabapp-customer');
            localStorage.removeItem('satabapp-translation');
            document.location.reload(true);
        },
         vCloseSidebar() {
            Bus.$emit('openSidebar');
            Bus.$emit('overlay');
        },
        getDivLogo() {
            customerService.getDivLogo()
            .then(res => {
                this.logo = res.data
            })
        }
    }
}
</script>

<style scoped>
#sidebar {
    min-width: 230px;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: #fff;
}
.picto-satab {
    height: 74px;
    display: flex;
    align-items: center;
    background-color: #F00B35;
    width: 100%;
    justify-content: center;
}
.picto-satab img {
    width: 50px;
}
.society-logo {
    border-bottom: solid 1px #E9E9E9;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 0px;
}
.society-logo img {
    max-width: 130px;
}
.btn-deconnect-container {

    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex:1;
}
.sidebar-container {
    flex: 1;
    text-align: center;
}
.sidebar-logo {
  padding: 30px;
}
.close-sidebar {
    padding: 15px 25px;
    display: none;
    justify-content: flex-end;
}
@media (max-width: 800px) { 
  .close-sidebar {
    display: flex;
  }
}

@media (max-width: 1370px) { 
  #sidebar {
    max-width: 100% !important;
    width: 100%;   
    height: 100vh !important; 
  }
}
</style>